import React, { useState, useContext } from "react";
import axios from "axios";
import { UPDATE_NOTIFICATION_URL } from "../Utils/URLs";
import { UserContext } from "./UserContext";

const NotificationState = () => {
    const [progress, setProgress] = useState(0)
   
    const { setnotificationRes } = useContext(UserContext)
    const UpdateNotification = async (id) => {

        try {

            await axios.post(UPDATE_NOTIFICATION_URL, { ids: id }).then((res) => {

                setnotificationRes(res.data.response)
            })

        } catch (error) {
            console.log(error)

        }
    }




    return {
        UpdateNotification,
       


    }
}

export default NotificationState